import React, { useContext, useState } from "react";
import { NavLink, Link } from "react-router-dom";
import './Navbar.css';

// Asset Imports
import logo1 from '../Assets/splogo.png';
import bag_icon from '../Assets/shopping-bag.png';
import user_icon from '../Assets/user.png';

import { ShopContext } from "../../Context/ShopContext";

const Navbar = () => {
    const { getTotalCartItems } = useContext(ShopContext);
    const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

    const toggleMobileMenu = () => {
        setMobileMenuOpen(!isMobileMenuOpen);
        document.body.classList.toggle('no-scroll', !isMobileMenuOpen);
    };

    const closeMenuAndScroll = () => {
        setMobileMenuOpen(false);
        document.body.classList.remove('no-scroll');
    };

    return (
        <header className={isMobileMenuOpen ? "navbar-header active" : "navbar-header"}>
            <div className="navbar container">
                <Link to='/' className="nav-logo" onClick={closeMenuAndScroll}>
                    <img src={logo1} alt="Streetwear logo" />
                </Link>

                <nav className="nav-menu">
                    <ul className="nav-list">
                        <li><NavLink to='/' onClick={closeMenuAndScroll}>Shop</NavLink></li>
                        <li><NavLink to='/sneakers' onClick={closeMenuAndScroll}>Sneakers</NavLink></li>
                        <li className="dropdown">
                            <NavLink to="/apparel">Apparel</NavLink>
                            <ul className="dropdown-content">
                                <li><NavLink to='/sketch' onClick={closeMenuAndScroll}>Sketch</NavLink></li>
                                <li><NavLink to='/gulueffect' onClick={closeMenuAndScroll}>Gulu Effect</NavLink></li>
                            </ul>
                        </li>
                    </ul>
                </nav>

                {/* --- NEW: RIGHT-SIDE ITEMS ARE NOW GROUPED --- */}
                <div className="navbar-right">
                    <div className="nav-actions">
                        <NavLink to='/login' className="nav-action-link" onClick={closeMenuAndScroll}>
                            <img src={user_icon} alt="User profile" />
                        </NavLink>
                        <NavLink to='/cart' className="nav-action-link" onClick={closeMenuAndScroll}>
                            <img src={bag_icon} alt="Shopping bag" />
                            <div className="nav-cart-count">{getTotalCartItems()}</div>
                        </NavLink>
                    </div>
                    <button className="nav-toggle" onClick={toggleMobileMenu} aria-label="Menu">
                        <span className="hamburger"></span>
                    </button>
                </div>
            </div>
        </header>
    );
}

export default Navbar;